<div class="expense-filters">
  <div class="filter-toggle" (click)="open()">
    <i class="fas fa-filter"></i>
    <span class="selected-count" [class.clear-enabled]="getSelectedCount() > 0">
      <span class="count">{{ getSelectedCount() }}</span>
      <span class="clear" *ngIf="getSelectedCount() > 0" (click)="clearAll($event)"><i class="fas fa-times"></i></span>
    </span>
  </div>
</div>

<app-modal #filtersModal [size]="ModalSize.Xs">
  <div class="modal-header">
    <h2 class="modal-title">Filters</h2>
    <button type="button" class="close" (click)="filtersModal.hide()" aria-label="Close">
      <span aria-hidden="true"><i class="far fa-times"></i></span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="filterForm" class="modal-form-full-width">
      <div class="form-group">
        <label>Trial</label>
        <app-trial-autocomplete #trialAutocomplete [form]="filterForm" controlName="trial" [returnTrialId]="true"
          placeholder="Search trial..." (valueChanged)="onTrialChanged($event)"></app-trial-autocomplete>
      </div>

      <div class="form-group">
        <label>Patient</label>
        <app-patient-autocomplete #patientAutocomplete [parentForm]="filterForm" controlName="patient"
          placeholder="Search by patient name, code or email..." (selectionChanged)="onPatientChanged($event)"></app-patient-autocomplete>
      </div>

      <div class="form-group">
        <label>Set as WIP by</label>
        <app-admin-autocomplete #wipAutocomplete [parentForm]="filterForm" controlName="wipBy"
          placeholder="Search admin..." (selectionChanged)="onWipChanged($event)"></app-admin-autocomplete>
      </div>

      <div class="filter-checkboxes">
        <div class="checkbox-row">
          <label class="checkbox-label" for="filter-preloads">View Preloads</label>
          <label class="checkbox">
            <input type="checkbox" id="filter-preloads" formControlName="preloads" (change)="onCheckboxChanged()">
            <span></span>
          </label>
        </div>

        <div class="checkbox-row">
          <label class="checkbox-label" for="filter-investigations">View Investigations</label>
          <label class="checkbox">
            <input type="checkbox" id="filter-investigations" formControlName="investigations" (change)="onCheckboxChanged()">
            <span></span>
          </label>
        </div>

        <div class="checkbox-row">
          <label class="checkbox-label" for="filter-onhold">View On-Hold</label>
          <label class="checkbox">
            <input type="checkbox" id="filter-onhold" formControlName="onhold" (change)="onCheckboxChanged()">
            <span></span>
          </label>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12">
        <app-button text="Done" (clicked)="applyFilters()" width="fill" />
      </div>
    </div>
  </div>
</app-modal>
